import { render, staticRenderFns } from "./adminBlockEdit.vue?vue&type=template&id=3d0e8680&scoped=true&"
import script from "./adminBlockEdit.vue?vue&type=script&lang=js&"
export * from "./adminBlockEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0e8680",
  null
  
)

export default component.exports